import React from 'react'
import "./main.css"
import "./com.css"



function Experience() {
    return (
        <div className="experience_container">
            <h2 id='titre_references'>Références</h2>
            <div className='exp_text_contain'>
                <h3 className='subtitle_references'>Ils nous ont fait confiance </h3>
                <div className='conf_grid_container'>
                    <div className='grid' id='grid01'></div>
                    <div className='grid' id='grid02'></div>
                    <div className='grid' id='grid03'></div>
                    <div className='grid' id='grid04'></div>
                    <div className='grid' id='grid05'></div>
                    <div className='grid' id='grid06'></div>
                    <div className='grid' id='grid07'></div>
                    <div className='grid' id='grid08'></div>
                    <div className='grid' id='grid09'></div>
                </div>
                <h3 className='subtitle_references'>Expériences en événementiel sportif</h3>
                <div className='exp_container'>
                    <ul className='list_exp'>
                        <li>Championnat d’Europe IQFoil – Club La Pelle – 2021</li>
                        <li>Championnat de France Longe Côte – FFRandonnée – 2021</li>
                        <li>Championnat d’Europe Bic Techno 293 – YCPR – 2020</li>
                        <li>Championnat du Monde Nacra 15 – YCPR – 2019</li>
                        <li>Championnat de Méditerranée Laser – YCPR - 2019</li>
                        <li>Championnats du Monde Jeunes 49er et Nacra 17 – YCPR – 2018</li>
                        <li>Championnats d’Europe FINN et RS:X – YCPR – 2017</li>
                        <li>Championnat de France Espoirs Glisse – YCPR – 2016</li>
                        
                    </ul>
                    <ul className='list_exp'>
                        <li>Les Voiles du Vieux Port - 2016</li>
                        <li>Coupe Internationale de Printemps Optimist – YCPR – 2016</li>
                        <li>Coupe Internationale de Printemps 470 – YCPR – 2015</li>
                        <li>Med Cup Windsurf – YCPR – de 2015 à 2021</li>
                        <li>Trophée Clairefontaine – Sailing One – 2009 à 2013</li>
                        <li>ICOM Cup Figaro – CEM – YCGM – 2012 et 2013</li>
                        <li>Le grand 8 Mini 6.50 – YCGM - 2012</li>
                        <li>Euregio’athlon - 1999</li>
                    </ul>
                </div>
                <div className='rajout_vide'></div>
            </div>
        </div>
    )
}

export default Experience
